export default __webpack_public_path__ + "assets/notification_icon.png";